export default __webpack_public_path__ + "static/offer-00edab5122eabcefd048468c34cc7553.jpg";